import { render, staticRenderFns } from "./RecruitmentPosition.vue?vue&type=template&id=1312e16d&scoped=true"
import script from "./RecruitmentPosition.vue?vue&type=script&lang=js"
export * from "./RecruitmentPosition.vue?vue&type=script&lang=js"
import style0 from "./RecruitmentPosition.vue?vue&type=style&index=0&id=1312e16d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1312e16d",
  null
  
)

export default component.exports